import { render, staticRenderFns } from "./ThePerPage.vue?vue&type=template&id=4c5d22b6&scoped=true"
import script from "./ThePerPage.vue?vue&type=script&lang=js"
export * from "./ThePerPage.vue?vue&type=script&lang=js"
import style0 from "./ThePerPage.vue?vue&type=style&index=0&id=4c5d22b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d22b6",
  null
  
)

export default component.exports